import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Slider from 'react-slick';
import { BiLeftArrowAlt, BiRightArrowAlt } from 'react-icons/bi';
import useTranslation from 'next-translate/useTranslation';
import { API, Comment as CommentType, Track } from '../../api';
import { useIsMobile } from '../../style/constants';
import {
  TextBold14,
  TextBold16,
  TextRegular14,
} from '../../VuexyDesign/atoms/Text';
import { Col, Row } from '../../VuexyDesign/atoms/_index';
import Loader from '../common/Loader';
import RelatedTracks from './RelatedTracks';
import Flex from '../common/Flex';
import { ProfileLinkStyled } from '../common/Link';
import { CenterLoader } from '../common/Miscellanea';

const SLIDES_TO_SHOW_DESKTOP = 5;
const SLIDES_TO_SHOW_MOBILE = 3;

function ReleasedTrackAdditionalInfo({
  track,
  comments,
  showLoadMoreBtn,
  loadMore,
  fetching,
}: ReleasedTrackAdditionalInfoProps) {
  const { t } = useTranslation('tracks');
  const isMobile = useIsMobile();
  const [recommendedTracks, setRecommendedTracks] = useState<Track[]>([]);
  const [loaderRecommendTracks, setLoaderRecommendTracks] = useState(false);
  const [commentsShownCount, setCommentsShownCount] = useState(4);

  useEffect(() => {
    setLoaderRecommendTracks(true);
    API.track
      .getAll({ user: track.user.id, sort: 'popular' })
      .then((resp) => {
        setRecommendedTracks(resp.tracks);
        setLoaderRecommendTracks(false);
      })
      .catch(() => {
        setLoaderRecommendTracks(false);
      });
  }, []);

  if (loaderRecommendTracks) {
    return (
      <div className="w-100 d-flex justify-content-center">
        <Loader />
      </div>
    );
  }

  const handleLoadMore = () => {
    // if (commentsShownCount % 20 === 0) {
    //   loadMore();
    // }
    loadMore();
    setCommentsShownCount((prev) => prev + 4);
  };

  return (
    <>
      {isMobile ? (
        <Row>
          <Col xs={12} className="d-flex ">
            <div className="d-flex">
              {comments && (
                <div
                  className="d-flex flex-column"
                  style={{ paddingTop: isMobile ? 18 : 10 }}
                >
                  {comments.length > 0 && (
                    <TextBold14>
                      {t('tracks:commentsFromUsers') as string}
                    </TextBold14>
                  )}
                  {comments.slice(0, commentsShownCount).map((comment) => (
                    <div className="mt-1 d-flex flex-column">
                      <Link href={`/profile/${comment.user.id}`}>
                        <div className="d-flex align-items-center cursor-pointer">
                          <Flex
                            style={{
                              borderRadius: '25px',
                              overflow: 'hidden',
                            }}
                          >
                            <img
                              alt="user pp"
                              src={comment.user.profile_photo}
                              width={20}
                              height={20}
                              loading="lazy"
                            />
                          </Flex>
                          <ProfileLinkStyled profileId={comment.user.id}>
                            <TextBold14 className="ml-1 ">
                              {comment.user.display_name}
                            </TextBold14>
                          </ProfileLinkStyled>
                        </div>
                      </Link>
                      <div
                        style={{ marginTop: '0.2rem', marginLeft: '2.45rem' }}
                      >
                        {comment.comment}
                      </div>
                    </div>
                  ))}
                  {showLoadMoreBtn && (
                    <TextRegular14
                      onClick={handleLoadMore}
                      style={{ opacity: 0.7 }}
                      className="cursor-pointer mt-1"
                    >
                      <u>{t('tracks:showMoreComments') as string}</u>
                    </TextRegular14>
                  )}
                </div>
              )}
            </div>
          </Col>
          <Col xs={12} className="mt-2">
            {recommendedTracks.length !== 0 ? (
              <>
                <div className="w-100 d-flex justify-content-between mb-1">
                  <TextBold16>
                    {t('tracks:moreTracksBy') as string}{' '}
                    {track.user.display_name}
                  </TextBold16>
                  <Link href={`/profile/${track.user.id}`}>
                    <TextBold14
                      className="cursor-pointer"
                      style={{ color: 'rgba(0, 0, 0, 0.8)' }}
                    >
                      {t('tracks:viewAll') as string}
                    </TextBold14>
                  </Link>
                </div>
              </>
            ) : (
              <></>
            )}

            <Slider
              dots={false}
              infinite={false}
              autoplay={false}
              slidesToShow={SLIDES_TO_SHOW_MOBILE}
              draggable={false}
              slidesToScroll={SLIDES_TO_SHOW_MOBILE}
              nextArrow={<NextArrow isMobile={isMobile} />}
              prevArrow={<PrevArrow isMobile={isMobile} />}
              className=""
            >
              {recommendedTracks.slice(0, 10).map((recommendedTrack) => (
                <div
                  key={`recommended-track-${recommendedTrack.id}`}
                  className="d-flex flex-column justify-content-center text-start px-1 "
                >
                  <Link href={`/tracks/${recommendedTrack.id}`}>
                    <div>
                      <Image
                        src={recommendedTrack.images['300x300']}
                        alt={recommendedTrack.title || 'test'}
                        width={125}
                        height={125}
                        className="cursor-pointer"
                        style={{
                          maxWidth: '100%',
                        }}
                      />
                      <TextBold14 className="cursor-pointer">
                        {recommendedTrack.title}
                      </TextBold14>
                    </div>
                  </Link>
                </div>
              ))}
            </Slider>
          </Col>
        </Row>
      ) : (
        <Row className="mt-1 mb-3">
          <Col lg={9}>
            <div className="d-flex">
              {comments && (
                <div
                  className="d-flex flex-column"
                  style={{ paddingTop: isMobile ? 18 : 10 }}
                >
                  {comments.length > 0 && (
                    <TextBold14>
                      {t('tracks:commentsFromUsers') as string}
                    </TextBold14>
                  )}
                  {comments.slice(0, commentsShownCount).map((comment) => (
                    <div className="d-flex flex-column mt-1">
                      <div>
                        <Link href={`/profile/${comment.user.id}`}>
                          <div className="d-flex align-items-center ">
                            <img
                              width={22}
                              height={22}
                              src={comment.user.profile_photo}
                              alt="user pp"
                              className="rounded-circle cursor-pointer"
                            />
                            <ProfileLinkStyled profileId={comment.user.id}>
                              <TextBold14 className="ml-1 ">
                                {comment.user.display_name}
                              </TextBold14>
                            </ProfileLinkStyled>
                          </div>
                        </Link>
                      </div>
                      <div
                        style={{ marginTop: '0.25rem', marginLeft: '2.45rem' }}
                        className="cursor-pointer"
                      >
                        {comment.comment}
                      </div>
                    </div>
                  ))}

                  {showLoadMoreBtn && (
                    <TextRegular14
                      onClick={handleLoadMore}
                      style={{ opacity: 0.7 }}
                      className="cursor-pointer mt-1"
                    >
                      <u>{t('tracks:showMoreComments') as string}</u>
                    </TextRegular14>
                  )}
                  {fetching && <CenterLoader />}
                </div>
              )}
            </div>

            <Row className="mr-1 mt-2">
              <Col xs={12}>
                {recommendedTracks.length !== 0 ? (
                  <div className="w-100 d-flex justify-content-between mb-1">
                    <TextBold16>
                      {t('tracks:moreTracksBy') as string}{' '}
                      {track.user.display_name}
                    </TextBold16>
                    <Link href={`/profile/${track.user.id}`}>
                      <TextBold14
                        className="cursor-pointer"
                        style={{ color: 'rgba(0, 0, 0, 0.8)' }}
                      >
                        {t('tracks:viewAll') as string}
                      </TextBold14>
                    </Link>
                  </div>
                ) : (
                  <></>
                )}
                <Slider
                  dots={false}
                  infinite={false}
                  autoplay={false}
                  slidesToShow={SLIDES_TO_SHOW_DESKTOP}
                  draggable={false}
                  slidesToScroll={SLIDES_TO_SHOW_DESKTOP}
                  nextArrow={<NextArrow isMobile={isMobile} />}
                  prevArrow={<PrevArrow isMobile={isMobile} />}
                  className=""
                >
                  {recommendedTracks.slice(0, 10).map((recommendedTrack) => (
                    <div
                      key={`recommended-track-${recommendedTrack.id}`}
                      className="d-flex flex-column justify-content-center text-start px-1 "
                    >
                      <Link href={`/tracks/${recommendedTrack.id}`}>
                        <div>
                          <Image
                            src={recommendedTrack.images['300x300']}
                            alt={recommendedTrack.title || 'test'}
                            width={125}
                            height={125}
                            className="cursor-pointer"
                            style={{
                              maxWidth: '100%',
                            }}
                          />
                          <TextBold14 className="cursor-pointer">
                            {recommendedTrack.title}
                          </TextBold14>
                        </div>
                      </Link>
                    </div>
                  ))}
                </Slider>
              </Col>
            </Row>
          </Col>
          {track.genre ? (
            <Col lg={3}>
              <RelatedTracks genreId={track.genre.id} />
            </Col>
          ) : (
            <></>
          )}
        </Row>
      )}
    </>
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const NextArrow = (props: any) => {
  const { style, onClick, slideCount, currentSlide, isMobile } = props;
  return (
    <>
      {!isMobile && currentSlide !== slideCount - SLIDES_TO_SHOW_DESKTOP && (
        <div
          style={{
            ...style,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '33px',
            backgroundColor: 'rgb(243, 242, 251)',
            height: '32px',
            position: 'absolute',
            top: '20%',
            right: '0px',
            zIndex: '10',
            cursor: 'pointer',
            borderRadius: '25px',
          }}
          onClick={onClick}
        >
          <BiRightArrowAlt size={35} />
        </div>
      )}
    </>
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const PrevArrow = (props: any) => {
  const { style, onClick, currentSlide, isMobile } = props;
  return (
    <>
      {!isMobile && currentSlide !== 0 && (
        <div
          style={{
            ...style,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '33px',
            backgroundColor: '#f3f2fb',
            boxShadow: '1px black',
            height: '32px',
            position: 'absolute',
            top: '20%',
            zIndex: '10',
            cursor: 'pointer',
            borderRadius: '25px',
          }}
          onClick={onClick}
        >
          <BiLeftArrowAlt size={35} />
        </div>
      )}
    </>
  );
};

export default ReleasedTrackAdditionalInfo;

interface ReleasedTrackAdditionalInfoProps {
  track: Track;
  comments: CommentType[];
  showLoadMoreBtn: boolean;
  loadMore: () => void;
  fetching: boolean;
}
